"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SELECTION_SIZE = exports.PARENT_FILTERS_CORRELATION = exports.RESET_CORRELATION = exports.SEARCH_CORRELATION = void 0;
/**
 * @internal
 */
exports.SEARCH_CORRELATION = "search";
/**
 * @internal
 */
exports.RESET_CORRELATION = "reset";
/**
 * @internal
 */
exports.PARENT_FILTERS_CORRELATION = "parentFilters";
/**
 * @internal
 */
exports.MAX_SELECTION_SIZE = 500;
//# sourceMappingURL=constants.js.map